export default defineNuxtRouteMiddleware((to, from) => {
	// Drop transient success/error banners when navigating to a new page so
	// feedback from the previous page doesn't linger. See CLEAR_MESSAGES.
	if (!from || to.fullPath === from.fullPath) return
	const { $store } = useNuxtApp()
	$store?.commit("CLEAR_MESSAGES")
})
